import React, { useEffect, useState } from 'react';
import {
  Button,
  ListGroup,
  Card,
  Modal,
  ToggleButtonGroup,
  ToggleButton,
  Form
} from 'react-bootstrap';
import { ArrowLeft } from 'react-bootstrap-icons';

const AdminProjectsTab = () => {
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [applicants, setApplicants] = useState([]);
  const [showApplicants, setShowApplicants] = useState(false);
  const [selectedApplicant, setSelectedApplicant] = useState(null);
  const [showApplicantModal, setShowApplicantModal] = useState(false);

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [technologies, setTechnologies] = useState('');
  const [category, setCategory] = useState('');
  const [startDate, setStartDate] = useState('');
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState('');
  const [viewMode, setViewMode] = useState('all');

  // --- EDIT Modal ---
  const [showEditModal, setShowEditModal] = useState(false);
  const [editProject, setEditProject] = useState(null);

  // --- DELETE Modal ---
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [projectToDelete, setProjectToDelete] = useState(null);

  const API_URL = process.env.REACT_APP_API_URL;

  // Fetch projects
  const loadProjects = () => {
    fetch(`${API_URL}/api/admin/projects`)
      .then(res => res.json())
      .then(data => setProjects(data))
      .catch(err => console.error('Error fetching projects:', err));
  };

  useEffect(() => { loadProjects(); }, [API_URL]);

  // Only show admin-created projects when viewMode is 'mine'
  const filteredProjects = viewMode === 'mine'
    ? projects.filter(p => !p.b2bId)
    : projects;

  const handleProjectClick = (project) => {
    setSelectedProject(project);
    setShowApplicants(false);
  };

  const handleBack = () => {
    setSelectedProject(null);
    setApplicants([]);
    setShowApplicants(false);
  };

  const fetchApplicants = async (projectId) => {
    try {
      const res = await fetch(`${API_URL}/api/admin/projects/${projectId}/applicants`);
      const data = await res.json();
      if (data && Array.isArray(data.applicants)) {
        setApplicants(data.applicants);
        setShowApplicants(true);
      } else {
        setApplicants([]);
        setShowApplicants(false);
      }
    } catch (err) {
      setApplicants([]); setShowApplicants(false);
    }
  };

  const fetchApplicantDetails = async (userId) => {
    try {
      const res = await fetch(`${API_URL}/api/admin/project-applicant/${userId}`);
      const data = await res.json();
      setSelectedApplicant(data);
      setShowApplicantModal(true);
    } catch (err) {}
  };

  // --- EDIT HANDLERS ---
  const openEditModal = (project) => {
    setEditProject({
      ...project,
      technologies: project.technologies?.join(', ') || '',
      category: project.category?.join(', ') || '',
      start_date: project.start_date ? project.start_date.split('T')[0] : ''
    });
    setShowEditModal(true);
  };

  const handleEditChange = e => {
    setEditProject({ ...editProject, [e.target.name]: e.target.value });
  };

  const handleUpdateProject = async () => {
    const payload = {
      title: editProject.title,
      description: editProject.description,
      technologies: editProject.technologies.split(',').map(t => t.trim()).filter(Boolean),
      category: editProject.category.split(',').map(c => c.trim()).filter(Boolean),
      start_date: editProject.start_date
    };
    try {
      const res = await fetch(`${API_URL}/api/admin/projects/${editProject._id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (res.ok) {
        setShowEditModal(false);
        setEditProject(null);
        loadProjects();
        // If updated, update selection as well
        if (selectedProject && selectedProject._id === editProject._id) {
          setSelectedProject({ ...selectedProject, ...payload });
        }
      } else {
        alert('Failed to update project.');
      }
    } catch (err) {
      alert('Network error.');
    }
  };

  // --- DELETE HANDLERS ---
  const openDeleteModal = (project) => {
    setProjectToDelete(project);
    setShowDeleteModal(true);
  };

  const handleDeleteProject = async () => {
    try {
      const res = await fetch(`${API_URL}/api/admin/projects/${projectToDelete._id}`, { method: 'DELETE' });
      if (res.ok) {
        setShowDeleteModal(false);
        setProjectToDelete(null);
        setSelectedProject(null);
        loadProjects();
      } else {
        alert('Failed to delete project.');
      }
    } catch (err) {
      alert('Network error.');
    }
  };

  return (
    <div>
      {/* Tabs for All Projects / My Projects */}
      <div className="mb-3 d-flex gap-2 align-items-center">
        <strong>View:</strong>
        <ToggleButtonGroup
          type="radio"
          name="viewMode"
          value={viewMode}
          onChange={val => setViewMode(val)}
        >
          <ToggleButton id="all-projects" value="all" variant={viewMode === 'all' ? 'primary' : 'outline-primary'}>All Projects</ToggleButton>
          <ToggleButton id="my-projects" value="mine" variant={viewMode === 'mine' ? 'primary' : 'outline-primary'}>My Projects</ToggleButton>
        </ToggleButtonGroup>
      </div>

      {!selectedProject && (
        <>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4>{viewMode === 'mine' ? 'My Projects' : 'All Projects'}</h4>
            <Button variant="primary" onClick={() => setShowCreateModal(true)}>
              + Create Project
            </Button>
          </div>
          {/* <ListGroup>
            {filteredProjects.map(p => (
              <ListGroup.Item
                key={p._id}
                action
                onClick={() => handleProjectClick(p)}
                className="d-flex justify-content-between align-items-center"
              >
                <div>
                  <strong>{p.title}</strong>
                  <div className="text-muted" style={{ fontSize: '0.9em' }}>{p.category?.join(', ')}</div>
                </div>
                <div className="d-flex gap-2">
               
                  {!p.b2bId &&
                    <Button
                      size="sm"
                      variant="outline-secondary"
                      onClick={e => { e.stopPropagation(); openEditModal(p); }}
                    >
                      Edit
                    </Button>
                  }
                 
                  <Button
                    size="sm"
                    variant="outline-danger"
                    onClick={e => { e.stopPropagation(); openDeleteModal(p); }}
                  >
                    Delete
                  </Button>
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup> */}

          <ListGroup>
            {filteredProjects.map(p => (
              <ListGroup.Item
                as="div"
                key={p._id}
                className="d-flex justify-content-between align-items-center"
              >
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => handleProjectClick(p)}
                >
                  <strong>{p.title}</strong>
                  <div className="text-muted" style={{ fontSize: '0.9em' }}>
                    {p.category?.join(', ')}
                  </div>
                </div>
                <div className="d-flex gap-2">
                  {/* Edit: Only for admin-created projects */}
                  {!p.b2bId && (
                    <Button
                      size="sm"
                      variant="outline-secondary"
                      onClick={e => { e.stopPropagation(); openEditModal(p); }}
                    >
                      Edit
                    </Button>
                  )}
                  {/* Delete: For all */}
                  <Button
                    size="sm"
                    variant="outline-danger"
                    onClick={e => { e.stopPropagation(); openDeleteModal(p); }}
                  >
                    Delete
                  </Button>
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>

        </>
      )}

      {selectedProject && !showApplicants && (
        <>
          <Button variant="link" className="mb-3" onClick={handleBack}>
            <ArrowLeft /> Back to Projects
          </Button>
          <Card className="p-3 shadow-sm">
            <h5>{selectedProject.title}</h5>
            <div>
              <strong>Description:</strong>
              <pre style={{
                whiteSpace: "pre-wrap",
                fontFamily: "inherit",
                background: "none",
                border: "none",
                margin: 0,
                padding: 0,
                fontSize: "1rem"
              }}>
                {selectedProject.description}
              </pre>
            </div>
            <p><strong>Technologies:</strong> {selectedProject.technologies?.join(', ')}</p>
            <p><strong>Category:</strong> {selectedProject.category?.join(', ')}</p>
            <p><strong>Start Date:</strong> {new Date(selectedProject.start_date).toLocaleDateString()}</p>
            <div className="d-flex gap-2 mb-2">
              {!selectedProject.b2bId && (
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => openEditModal(selectedProject)}
                >Edit</Button>
              )}
              <Button
                size="sm"
                variant="outline-danger"
                onClick={() => openDeleteModal(selectedProject)}
              >Delete</Button>
            </div>
            <Button onClick={() => fetchApplicants(selectedProject._id)}>Applicants</Button>
          </Card>
        </>
      )}

      {selectedProject && showApplicants && (
        <>
          <Button variant="link" className="mb-3" onClick={() => setShowApplicants(false)}>
            <ArrowLeft /> Back to Project Details
          </Button>
          <Card className="p-3 shadow-sm">
            <h5>Applicants for {selectedProject.title}</h5>
            <ListGroup>
              {applicants.map((a, i) => (
                <ListGroup.Item key={i} action onClick={() => fetchApplicantDetails(a.userId)}>
                  <strong>{a.name}</strong> ({a.role})
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Card>
        </>
      )}

      {/* --- Edit Modal --- */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Project</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-2">
              <Form.Label>Title</Form.Label>
              <Form.Control
                value={editProject?.title || ''}
                name="title"
                onChange={handleEditChange}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                value={editProject?.description || ''}
                name="description"
                onChange={handleEditChange}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Technologies (comma separated)</Form.Label>
              <Form.Control
                value={editProject?.technologies || ''}
                name="technologies"
                onChange={handleEditChange}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Category (comma separated)</Form.Label>
              <Form.Control
                value={editProject?.category || ''}
                name="category"
                onChange={handleEditChange}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type="date"
                value={editProject?.start_date || ''}
                name="start_date"
                onChange={handleEditChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleUpdateProject}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>

      {/* --- Delete Modal --- */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the project <b>{projectToDelete?.title}</b>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteProject}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* --- Create Modal (unchanged) --- */}
      <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Create New Project</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="mb-3">
              <label className="form-label">Title</label>
              <input
                type="text"
                className="form-control"
                value={title}
                onChange={e => setTitle(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Description</label>
              <textarea
                className="form-control"
                value={description}
                onChange={e => setDescription(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Technologies (comma separated)</label>
              <input
                type="text"
                className="form-control"
                value={technologies}
                onChange={e => setTechnologies(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Category (comma separated)</label>
              <input
                type="text"
                className="form-control"
                value={category}
                onChange={e => setCategory(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Start Date</label>
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={e => setStartDate(e.target.value)}
              />
            </div>
          </form>
          {error && <div className="text-danger mt-2">{error}</div>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={async () => {
              setCreating(true);
              setError('');
              const payload = {
                title,
                description,
                technologies: technologies.split(',').map(t => t.trim()).filter(Boolean),
                category: category.split(',').map(c => c.trim()).filter(Boolean),
                start_date: startDate
              };
              try {
                const res = await fetch(`${API_URL}/api/admin/create-project`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(payload)
                });
                const data = await res.json();
                if (res.ok) {
                  setShowCreateModal(false);
                  setTitle('');
                  setDescription('');
                  setTechnologies('');
                  setCategory('');
                  setStartDate('');
                  loadProjects();
                } else {
                  setError(data.error || 'Failed to create project.');
                }
              } catch (err) {
                setError('Network error. Please try again.');
              } finally {
                setCreating(false);
              }
            }}
            disabled={creating}
          >
            {creating ? 'Creating...' : 'Create Project'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AdminProjectsTab;
